import { useState } from 'react';

// Access code — change this to any code you want
const ACCESS_CODE = 'SBS2024';
const SESSION_KEY = 'sbs_notes_unlocked';
const WA_MSG = encodeURIComponent('Hello, I want access to notes');
const WA_LINK = `https://wa.me/917417652434?text=${WA_MSG}`;

export default function NotesGate({ onUnlock }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const [attempts, setAttempts] = useState(0);

  const handleSubmit = e => {
    e.preventDefault();
    if (code.trim().toUpperCase() === ACCESS_CODE) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      onUnlock();
    } else {
      setAttempts(a => a + 1);
      setError('Invalid Code. Please try again.');
      setShake(true);
      setCode('');
      setTimeout(() => setShake(false), 600);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      background: 'linear-gradient(135deg, #EFF6FF 0%, #F8FAFC 60%, #F0FDF4 100%)',
    }}>
      <div style={{ width: '100%', maxWidth: 460 }}>

        {/* Lock icon header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{
            width: 80, height: 80,
            background: 'var(--blue)',
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 1.2rem',
            boxShadow: '0 8px 24px rgba(30,58,138,0.25)',
            fontSize: '2rem',
          }}>🔒</div>
          <h2 style={{ fontSize: '1.7rem', fontWeight: 800, color: 'var(--dark)' }}>
            Study Notes Access
          </h2>
          <p style={{ color: 'var(--gray)', marginTop: '0.5rem', fontSize: '0.95rem', lineHeight: 1.6 }}>
            Enter your access code to view and download<br />study materials
          </p>
        </div>

        {/* Card */}
        <div style={{
          background: '#fff',
          border: '1px solid var(--border)',
          borderRadius: 16,
          padding: '2.2rem',
          boxShadow: '0 4px 24px rgba(30,58,138,0.08)',
          animation: shake ? 'gateShake 0.5s ease' : 'none',
        }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className="form-group">
              <label style={{ fontWeight: 700, color: 'var(--dark)', fontSize: '0.88rem' }}>
                Access Code
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  value={code}
                  onChange={e => { setCode(e.target.value); setError(''); }}
                  placeholder="Enter your access code"
                  autoComplete="off"
                  autoFocus
                  style={{
                    width: '100%',
                    background: '#fff',
                    border: `1.5px solid ${error ? 'var(--red)' : 'var(--border)'}`,
                    borderRadius: 8,
                    padding: '0.85rem 1rem 0.85rem 2.8rem',
                    color: 'var(--dark)',
                    fontSize: '1rem',
                    fontFamily: 'inherit',
                    letterSpacing: '0.1em',
                    transition: 'border-color 0.2s, box-shadow 0.2s',
                    outline: 'none',
                  }}
                  onFocus={e => { if (!error) e.target.style.borderColor = 'var(--blue-mid)'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.1)'; }}
                  onBlur={e => { if (!error) e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }}
                />
                <span style={{
                  position: 'absolute', left: '0.9rem', top: '50%',
                  transform: 'translateY(-50%)',
                  fontSize: '1rem', pointerEvents: 'none',
                }}>🔑</span>
              </div>
            </div>

            {/* Error message */}
            {error && (
              <div className="alert alert-error" style={{ padding: '0.65rem 1rem' }}>
                ❌ {error}
                {attempts >= 2 && (
                  <span style={{ marginLeft: '0.5rem', fontSize: '0.82rem' }}>
                    — Get your code via WhatsApp below
                  </span>
                )}
              </div>
            )}

            <button
              type="submit"
              style={{
                background: 'var(--blue)',
                color: '#fff',
                padding: '0.9rem',
                borderRadius: 8,
                border: 'none',
                fontWeight: 700,
                fontSize: '1rem',
                cursor: 'pointer',
                transition: 'background 0.2s, transform 0.15s',
                fontFamily: 'inherit',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'var(--blue-mid)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'var(--blue)'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              Unlock Notes →
            </button>
          </form>

          {/* Divider */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: '0.8rem',
            margin: '1.5rem 0',
          }}>
            <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
            <span style={{ color: 'var(--gray)', fontSize: '0.82rem' }}>Don't have a code?</span>
            <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
          </div>

          {/* WhatsApp CTA */}
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.6rem',
              background: '#25D366',
              color: '#fff',
              padding: '0.85rem',
              borderRadius: 8,
              fontWeight: 700,
              fontSize: '0.95rem',
              textDecoration: 'none',
              boxShadow: '0 4px 14px rgba(37,211,102,0.3)',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#16A34A'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#25D366'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            Get Access Code via WhatsApp
          </a>

          <p style={{ textAlign: 'center', color: 'var(--gray)', fontSize: '0.78rem', marginTop: '1.2rem', lineHeight: 1.6 }}>
            📲 Message us on WhatsApp and our team will share<br />your personal access code within minutes.
          </p>
        </div>

        {/* Info strip */}
        <div style={{
          marginTop: '1.2rem',
          background: 'var(--blue-pale)',
          border: '1px solid #BFDBFE',
          borderRadius: 10,
          padding: '0.9rem 1.2rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.7rem',
          fontSize: '0.83rem',
          color: 'var(--blue)',
        }}>
          <span style={{ fontSize: '1.1rem' }}>ℹ️</span>
          Access codes are valid for enrolled students only. Each code is unique and session-based.
        </div>
      </div>

      {/* Shake keyframe injected inline */}
      <style>{`
        @keyframes gateShake {
          0%, 100% { transform: translateX(0); }
          20%       { transform: translateX(-8px); }
          40%       { transform: translateX(8px); }
          60%       { transform: translateX(-5px); }
          80%       { transform: translateX(5px); }
        }
      `}</style>
    </div>
  );
}
